import SPXStrangleBacktestTable from './SPXStrangleBacktestTable';

// Data from backend/cmd/spx20ptbacktest -distance=20, run against real
// historical Alpaca data 2026-06-01..2026-07-16. See SPXStrangleBacktestTable
// for the row-shape contract and the overall rules (3:50 PM entry, hold to
// close, $500 running budget never replenished, no fee).
const ROWS = [
  ['01-06-2026', 7615.72, 'CALL', 7635, 'filled', 0.03, 0.03, 0.05, 0.03, 0.00, 0.00, 497.00],
  ['01-06-2026', 7615.72, 'PUT', 7595, 'filled', 0.28, 0.05, 0.60, 0.02, -23.00, -82.14, 469.00],
  ['02-06-2026', 7619.58, 'CALL', 7640, 'filled', 0.05, 0.04, 0.05, 0.02, -1.00, -20.00, 464.00],
  ['02-06-2026', 7619.58, 'PUT', 7600, 'filled', 0.10, 0.03, 0.12, 0.01, -7.00, -70.00, 454.00],
  ['03-06-2026', 7577.22, 'CALL', 7595, 'filled', 0.03, 0.05, 0.05, 0.03, 2.00, 66.67, 451.00],
  ['03-06-2026', 7577.22, 'PUT', 7555, 'filled', 0.07, 0.75, 2.00, 0.01, 68.00, 971.43, 444.00],
  ['04-06-2026', 7573.71, 'CALL', 7595, 'filled', 1.45, 0.03, 2.00, 0.01, -142.00, -97.93, 299.00],
  ['04-06-2026', 7573.71, 'PUT', 7555, 'filled', 0.05, 0.03, 0.05, 0.01, -2.00, -40.00, 294.00],
  ['05-06-2026', 7401.30, 'CALL', 7420, 'filled', 1.05, 0.05, 2.05, 0.03, -100.00, -95.24, 189.00],
  ['05-06-2026', 7401.30, 'PUT', 7380, 'filled', 0.70, 0.05, 1.10, 0.01, -65.00, -92.86, 119.00],
  ['08-06-2026', 7400.33, 'CALL', 7420, 'filled', 0.35, 0.03, 1.00, 0.02, -32.00, -91.43, 84.00],
  ['08-06-2026', 7400.33, 'PUT', 7380, 'filled', 0.10, 0.03, 0.15, 0.02, -7.00, -70.00, 74.00],
  ['09-06-2026', 7332.63, 'CALL', 7355, 'skipped_budget', 1.95, 74.00],
  ['09-06-2026', 7332.63, 'PUT', 7315, 'filled', 0.45, 0.03, 0.55, 0.03, -42.00, -93.33, 29.00],
  ['10-06-2026', 7284.59, 'CALL', 7305, 'filled', 0.25, 0.02, 1.00, 0.02, -23.00, -92.00, 4.00],
  ['10-06-2026', 7284.59, 'PUT', 7265, 'skipped_budget', 1.30, 4.00],
  ['11-06-2026', 7379.87, 'CALL', 7400, 'skipped_budget', 2.85, 4.00],
  ['11-06-2026', 7379.87, 'PUT', 7360, 'skipped_budget', 0.15, 4.00],
  ['12-06-2026', 7412.35, 'CALL', 7430, 'skipped_budget', 1.40, 4.00],
  ['12-06-2026', 7412.35, 'PUT', 7390, 'skipped_budget', 0.07, 4.00],
  ['15-06-2026', 7545.14, 'CALL', 7565, 'skipped_budget', 0.60, 4.00],
  ['15-06-2026', 7545.14, 'PUT', 7525, 'filled', 0.03, 0.05, 0.10, 0.01, 2.00, 66.67, 1.00],
  ['16-06-2026', 7511.17, 'CALL', 7530, 'skipped_budget', 0.35, 1.00],
  ['16-06-2026', 7511.17, 'PUT', 7490, 'skipped_budget', 0.08, 1.00],
  ['17-06-2026', 7419.64, 'CALL', 7440, 'skipped_budget', 0.55, 1.00],
  ['17-06-2026', 7419.64, 'PUT', 7400, 'skipped_budget', 1.65, 1.00],
  ['18-06-2026', 7479.65, 'CALL', 7500, 'skipped_budget', 3.60, 1.00],
  ['18-06-2026', 7479.65, 'PUT', 7460, 'skipped_budget', 0.07, 1.00],
  ['22-06-2026', 7461.62, 'CALL', 7480, 'skipped_budget', 0.12, 1.00],
  ['22-06-2026', 7461.62, 'PUT', 7440, 'skipped_budget', 0.07, 1.00],
  ['23-06-2026', 7376.15, 'CALL', 7395, 'skipped_budget', 0.31, 1.00],
  ['23-06-2026', 7376.15, 'PUT', 7355, 'skipped_budget', 0.23, 1.00],
  ['24-06-2026', 7340.30, 'CALL', 7360, 'skipped_budget', 1.10, 1.00],
  ['24-06-2026', 7340.30, 'PUT', 7320, 'skipped_budget', 0.10, 1.00],
  ['25-06-2026', 7333.46, 'CALL', 7355, 'skipped_budget', 1.55, 1.00],
  ['25-06-2026', 7333.46, 'PUT', 7315, 'skipped_budget', 0.03, 1.00],
  ['26-06-2026', 7353.77, 'CALL', 7375, 'skipped_budget', 0.49, 1.00],
  ['26-06-2026', 7353.77, 'PUT', 7335, 'skipped_budget', 0.07, 1.00],
  ['29-06-2026', 7435.33, 'CALL', 7455, 'skipped_budget', 0.12, 1.00],
  ['29-06-2026', 7435.33, 'PUT', 7415, 'skipped_budget', 0.07, 1.00],
  ['30-06-2026', 7497.58, 'CALL', 7520, 'skipped_budget', 0.15, 1.00],
  ['30-06-2026', 7497.58, 'PUT', 7480, 'skipped_budget', 0.27, 1.00],
  ['01-07-2026', 7494.60, 'CALL', 7515, 'skipped_budget', 0.05, 1.00],
  ['01-07-2026', 7494.60, 'PUT', 7475, 'skipped_budget', 0.19, 1.00],
  ['02-07-2026', 7453.82, 'CALL', 7475, 'skipped_budget', 0.40, 1.00],
  ['02-07-2026', 7453.82, 'PUT', 7435, 'skipped_budget', 0.07, 1.00],
  ['06-07-2026', 7539.75, 'CALL', 7560, 'skipped_budget', 0.17, 1.00],
  ['06-07-2026', 7539.75, 'PUT', 7520, 'skipped_budget', 0.07, 1.00],
  ['07-07-2026', 7483.97, 'CALL', 7505, 'skipped_budget', 0.75, 1.00],
  ['07-07-2026', 7483.97, 'PUT', 7465, 'skipped_budget', 0.07, 1.00],
  ['08-07-2026', 7492.84, 'CALL', 7515, 'skipped_budget', 0.03, 1.00],
  ['08-07-2026', 7492.84, 'PUT', 7475, 'skipped_budget', 3.90, 1.00],
  ['09-07-2026', 7530.90, 'CALL', 7550, 'skipped_budget', 0.15, 1.00],
  ['09-07-2026', 7530.90, 'PUT', 7510, 'skipped_budget', 0.10, 1.00],
  ['10-07-2026', 7578.35, 'CALL', 7600, 'skipped_budget', 0.05, 1.00],
  ['10-07-2026', 7578.35, 'PUT', 7560, 'skipped_budget', 0.15, 1.00],
  ['13-07-2026', 7511.62, 'CALL', 7530, 'skipped_budget', 0.15, 1.00],
  ['13-07-2026', 7511.62, 'PUT', 7490, 'skipped_budget', 0.07, 1.00],
  ['14-07-2026', 7552.66, 'CALL', 7575, 'skipped_budget', 0.03, 1.00],
  ['14-07-2026', 7552.66, 'PUT', 7535, 'skipped_budget', 0.07, 1.00],
  ['15-07-2026', 7565.60, 'CALL', 7585, 'skipped_budget', 0.03, 1.00],
  ['15-07-2026', 7565.60, 'PUT', 7545, 'skipped_budget', 0.10, 1.00],
  ['16-07-2026', 7513.31, 'CALL', 7535, 'skipped_budget', 0.02, 1.00],
  ['16-07-2026', 7513.31, 'PUT', 7495, 'skipped_budget', 0.45, 1.00],
];

export default function SPX20PointStrangleTable() {
  return (
    <SPXStrangleBacktestTable
      title="SPX 20pt Strangle @ 3:50 PM — Hold to Close"
      subtitle="2026-06-01 → 2026-07-16, one-off run against real historical data. Every day at 3:50 PM ET: buy 1 call ~20pts above spot and 1 put ~20pts below, hold both to the close, never sell. $500 is a single running budget for the whole window (not per-day, not replenished by expiry — a leg is skipped only when its own cost would exceed what's left). No commission was specified for this test. SPX spot derived from the real opens you gave, scaled by each day's own SPY move. Ran out of budget by 2026-06-10 (day 8 of 30) — everything after is skipped."
      rows={ROWS}
    />
  );
}
